// @flow
// import {withChangeLanguage} from '@userstory/i18n';
// import type {TLanguageList} from '@userstory/i18n';
import {Prefetch} from 'app/components/Prefetch';
import {CookieBannerRender} from 'app/components/CookieBannerRender';
import AppRoutes from 'app/routes';
// import {useLogOut} from 'modules/auth/hooks/use-auth';
// import {selectIsAuthorized} from 'modules/auth/selectors/auth';
import React from 'react';
import {Helmet} from 'react-helmet';
// import {useSelector} from 'react-redux';
// import {Link} from 'react-router-dom';

// type TPropsChangeLanguage = {
//     handleChangeLanguage: (string) => void,
//     languageKey: string,
//     languageList: TLanguageList,
// };

/**
 * Корневой компонент
 * @returns React-компонент
 */
export const RootContainer = () => {
    // const isAuthorized = useSelector(selectIsAuthorized);
    // const logOut = useLogOut();
    // TODO: Оставить здесь только Prefetch, Helmet и AppRoutes.
    return (
        <Prefetch>
            <Helmet titleTemplate="%s - MySite.com" />
            {/* <h1>React App</h1>
            {isAuthorized && <button onClick={logOut}>Выйти</button>}
            <select
                id="language-select"
                name="language-select"
                onBlur={null}
                onChange={(e) => handleChangeLanguage(e.currentTarget.value)}
                value={languageKey}
            >
                {Object.keys(languageList).map((key) => {
                    return (
                        <option key={languageList[key].code} value={languageList[key].code}>
                            {languageList[key].name}
                        </option>
                    );
                })}
            </select>

            <ul>
                <li>
                    <Link to="/">Форма авторизации</Link>
                </li>
                <li>
                    <Link to="/styleguide">Стайлгайд</Link>
                </li>
                <li>
                    <Link to="/404">404</Link>
                </li>
            </ul>*/}
            <AppRoutes />
            <CookieBannerRender />
        </Prefetch>
    );
};
